class DeploymentConfig {
  constructor(
    tag = undefined,
    model = undefined,
    fractions = [],
    mappings = {},
    display = undefined,
    useExposureAlgorithm = false
  ) {
    this.tag = tag;
    this.model = model;
    this.fractions = fractions;
    this.mappings = mappings;
    this.display = display;
    this.useExposureAlgorithm = useExposureAlgorithm;
  }

  static deploymentConfigFromAddingNewInstance(deploymentConfig, newInstanceConfig) {
    var newValue = new DeploymentConfig();
    for (let property in newValue) {
      const oldPropertyValue = deploymentConfig[property];
      const newPropertyValue = newInstanceConfig[property];
      if (oldPropertyValue == newPropertyValue) {
        newValue[property] = oldPropertyValue;
      } else {
        newValue[property] = undefined;
      }
    }
    return newValue;
  }
}

export default DeploymentConfig;